import React, {
    useEffect,
    useState
} from 'react';
import AuditLogRepository from "../../../repositories/AuditLogRepository";
import LogDialog from "../LogDialog";

const ParkingEventLogView = ({id, onClose}) => {

    const [list, setList] = useState(null);
    const repository = new AuditLogRepository();

    const handleClose = () => {
        if (onClose) {
            onClose({ id : id });
        }
    };

    useEffect(() => {

      async function fetchData() {

          try {
              const rs = await repository.getForParkingEvent(id);
              setList(rs.data.Items);
          } catch (e) {
              handleClose();
          }
      }

      fetchData();

    }, [id]);

	return (<LogDialog list={list} onClose={handleClose} />);
};

export default ParkingEventLogView;